import { trans } from "@mongez/localization";
import { CustomOption, productAtom } from "core/catalog";
import { useCalculateCustomOptionsPrice } from "~/modules/product-details/hooks";
import { CheckboxInputOption } from "./CheckboxInputOption";
import { ColorInputOption } from "./ColorInputOption";
import { DateInputOption } from "./DateInputOption";
import { FileInputOption } from "./FileInputOption";
import { NumberInputOption } from "./NumberInputOption";
import { RadioInputOption } from "./RadioInputOption";
import { SelectInputOption } from "./SelectInputOption";
import { TextInputOption } from "./TextInputOption";
import { TextareaInputOption } from "./TextareaInputOption";

const customOptionComponents = {
  select: SelectInputOption,
  multiSelect: SelectInputOption,
  text: TextInputOption,
  textarea: TextareaInputOption,
  checkbox: CheckboxInputOption,
  radio: RadioInputOption,
  file: FileInputOption,
  number: NumberInputOption,
  date: DateInputOption,
  image: FileInputOption,
  color: ColorInputOption,
};

export function CustomOptions() {
  const product = productAtom.use("product");

  const customOptions: CustomOption[] = product?.customOptions || [];

  const { handleOptionChange } = useCalculateCustomOptionsPrice();

  const getOnChangeHandler = (optionId: string) => {
    return (value: string | string[] | number | boolean) => {
      // Convert boolean to string if needed (though booleans shouldn't reach here since hasPriceValues would be false)
      const normalizedValue: string | string[] | number = Array.isArray(value)
        ? value
        : typeof value === "boolean"
          ? String(value)
          : value;

      handleOptionChange(optionId, normalizedValue);
    };
  };

  if (customOptions.length === 0) return null;

  const sortedCustomOptions = customOptions.sort(
    (a, b) => Number(a.sortOrder) - Number(b.sortOrder),
  );

  return (
    <div className="flex flex-col gap-6">
      <h3 className="text-lg font-bold">{trans("customOptions")}</h3>
      <div className="flex flex-col gap-5">
        {sortedCustomOptions.map((customOption) => {
          const Component = customOptionComponents[customOption.type];

          if (Component) {
            return (
              <Component
                key={customOption.id}
                customOption={customOption}
                onChange={getOnChangeHandler(customOption.id)}
              />
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}
